import React from "react";
import { Box, Typography } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

export default function GenderHeader() {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          marginTop: "2rem",
          height: "3.6875em",
          borderRadius: "3.5625em",
          backgroundColor: "#ede838",
        }}
      >
        <Box
          sx={{
            display: "inline-block",
            width: "1.625em",
            height: "1.625em",
            padding: "0.625em",
            border: "1.25em",
            marginLeft: "0.875em",
            marginTop: "0.4375em",
            marginBottom: "0.875em",
            borderRadius: "1.25em",
            backgroundColor: "#F9F9F9",
            //overflow: "hidden",
            position: "relative",
          }}
        >
          <HelpIcon
            sx={{ position: "relative", width: "100%", height: "auto" }}
          />
        </Box>
        <Box
          sx={{
            display: "inline-block",
            verticalAlign: "super",
            paddingLeft: "0.625em",
            fontSize: "1.25em",
            fontFamily: "Inter",
          }}
        >
          <Typography
            variant="h6"
            color={"#000000"}
            paddingLeft={"0.3em"}
            letterSpacing={0}
            fontWeight={700}
            fontFamily={"Inter, Helvetica, sans-serif"}
          >
            Genderometer
          </Typography>
        </Box>
      </Box>
    </>
  );
}
